import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setContent, setMedium, setSource } from "@App/state/reducers/analytics";
import { z } from "zod";
import { useSafeSearchParams } from "@App/hooks/reactRouter/useSafeSearchParams";
import { State } from "@App/state";

export const useAnalyticsParameters = () => {
  const source = useSelector((state: State) => state.analytics.source);
  const medium = useSelector((state: State) => state.analytics.medium);
  const content = useSelector((state: State) => state.analytics.content);

  const dispatch = useDispatch();
  const safeSearchParams = useSafeSearchParams(
    z.object({
      utm_source: z.string().trim().max(200).optional(),
      utm_medium: z.string().trim().max(200).optional(),
      utm_content: z.string().trim().max(200).optional(),
    }),
  );

  useEffect(() => {
    if (!safeSearchParams) return;
    if (source || medium || content) return; // only set once

    const sourceParam = safeSearchParams.utm_source;
    const mediumParam = safeSearchParams.utm_medium;
    const contentParam = safeSearchParams.utm_content;

    if (sourceParam) dispatch(setSource(sourceParam));
    if (mediumParam) dispatch(setMedium(mediumParam));
    if (contentParam) dispatch(setContent(contentParam));
  }, [safeSearchParams]);

  const analyticsQueryParams = (): Record<string, string> => {
    return {
      ...(source && { utm_source: source }),
      ...(medium && { utm_medium: medium }),
      ...(content && { utm_content: content }),
    };
  };

  return { analyticsQueryParams };
};
